import { render, staticRenderFns } from "./inpt_type_select.vue?vue&type=template&id=c158edd6"
import script from "./inpt_type_select.vue?vue&type=script&lang=js"
export * from "./inpt_type_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports